import React from 'react';
import {InputFieldProps} from "./InputField";
import {useField} from "formik";
import {Scheme, UrlInput} from "../Control";

// Types ----

type CustomProps = {
  label?: string
  hint?: string
  help?: string
  schemes?: Scheme[]
  onChangeUrl?: (val: string) => void;
  onChangeScheme?: (scheme: Scheme) => void
  disabled?: boolean
  required?: boolean
}

export type UrlFieldProps = Omit<InputFieldProps, 'type'>
  & CustomProps

// Component ----

function UrlField(props: UrlFieldProps) {
  const [field, meta, {setValue, setTouched}] = useField(props);
  const error = (meta.touched && !!meta.error)? meta.error : null

  function handleChange(url: string) {
    void setTouched(true);
    void setValue(url);
    props?.onChangeUrl?.(url);
  }

  function handleChangeScheme(scheme: Scheme) {
    props.onChangeScheme?.(scheme)
  }

  return (
    <UrlInput
      name={field.name}
      label={props.label}
      value={field.value}
      onChange={handleChange}
      hint={props.hint}
      help={props.help}
      error={error}
      schemes={props.schemes}
      onChangeScheme={handleChangeScheme}
      disabled={props.disabled}
      required={props.required}
    />
  )
}

export default UrlField;